export class TenantConfig {

    public name: string;
    public apiProdUrl: string;
    public apiTestUrl: string;
    public appName: string;
    public lang: string;
    public transaction: boolean
  
    constructor (
      name: string,
      apiProdUrl: string,
      apiTestUrl: string,
      transaction: boolean = true,
      appName: string = 'WebProduction',
      lang: string = 'bg',
    ) {
      this.name = name;
      this.apiProdUrl = apiProdUrl;
      this.apiTestUrl = apiTestUrl;
      this.appName = appName;
      this.lang = lang;
      this.transaction = transaction;
    }

    public getApi(): string {
      return this.apiProdUrl;
    }
  }